import {
  Box,
  Dialog,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useMemo, useState } from "react";
import { UserContext } from "components/context/UserProvider";
import LaunchIcon from "@mui/icons-material/Launch";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { useAddToGoogle } from "models/contacts/apiContact";
import { SnackbarContext } from "components/context/SnackbarProvider";

const WithIconAndMore = ({ Icon, items }) => {
  const [open, setOpen] = useState(false);

  if (!items || items.length == 0) return <></>;

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <List>
          {items.map((item, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <Icon fontSize="small" sx={{ mr: 1 }} />
        <Typography variant="body2" noWrap overflow={"hidden"}>
          {items[0]}
        </Typography>
        {items.length > 1 && (
          <Link
            component="button"
            variant="body2"
            onClick={() => setOpen(true)}
            sx={{ ml: 1 }}
          >
            more
          </Link>
        )}
      </Box>
    </>
  );
};

const ContactItem = ({ object: contact }) => {
  const { user } = useContext(UserContext);
  const { displayMessage, displayError } = useContext(SnackbarContext);
  const { mutateAsync } = useAddToGoogle();
  const save = (contact_id) => {
    return mutateAsync(contact_id)
      .then(() => {
        displayMessage("saved !");
      })
      .catch(displayError);
  };

  const secondaryAction = useMemo(() => {
    if (user.id == contact.account.user.id)
      return (
        <IconButton
          target="_blank"
          href={contact.link_address_book}
          fontSize="small"
        >
          <LaunchIcon fontSize="small" />
        </IconButton>
      );
    else
      return (
        <IconButton onClick={() => save(contact.id)}>
          <SaveAltIcon fontSize="small" />
        </IconButton>
      );
  }, [contact, user]);

  return (
    <ListItem key={contact.id} secondaryAction={secondaryAction}>
      <ListItemText
        primary={contact.name}
        secondary={`${contact.organization} in ${contact.account.name}'s address book`}
      />
      <Stack sx={{ maxWidth: "50%", ml: 1 }}>
        <WithIconAndMore Icon={EmailIcon} items={contact.email_addresses} />
        <WithIconAndMore Icon={PhoneIcon} items={contact.phone_numbers} />
      </Stack>
    </ListItem>
  );
};

export default ContactItem;
